import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The top-bar status while procedural textures are still building or uploading.
 * A capture harness waits for it to detach (ADR-0042).
 */
import { usePendingWork } from '../../../resources/usePendingWork.js';
import { textureWork } from '../../../resources/textures/textureWork.js';
import { StatusChip } from './StatusChip.js';
import { TEXTURE_WORK_STATUS_TESTID } from './statusTestIds.js';
export function TextureWorkStatus() {
    if (usePendingWork(textureWork) === 0)
        return null;
    return _jsx(StatusChip, { label: "Building textures\u2026", testId: TEXTURE_WORK_STATUS_TESTID });
}
//# sourceMappingURL=TextureWorkStatus.js.map